'use client';

import { H2Large } from 'components/home/styleConstants';
import { CustomImage as Image } from '..';
import React from 'react';
import styles from './InTheBox.module.css';
import { useRef } from 'react';
import { useTranslations } from 'next-intl';

const Wrapper = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={`${styles.wrapper} u-grid ${styles.root}${
      className ? ` ${className}` : ''
    }`}
    {...props}
  >
    {children}
  </div>
));

Wrapper.displayName = 'Wrapper';

export const InTheBox = ({
  className,
  htmlId,
}: {
  className?: string;
  htmlId?: string;
}) => {
    const t = useTranslations('uhHome');
    const tRing = useTranslations('ring');
    const rootRef = useRef<HTMLDivElement>(null);

    const data = [
      {
        image: 'web_v2/home/buy/in-the-box/Desktop/home_top.png/w_800',
        title: t('uhHome.inTheBox.data.Home'),
      },
      {
        image: 'web_v2/home/buy/in-the-box/Desktop/Charger_home.png/w_800',
        title: t('uhHome.inTheBox.data.Charger'),
      },
      {
        image: 'web_v2/illustrations/content-cable.png/w_800',
        title: t('uhHome.inTheBox.data.Cable'),
      },
    ];

    return (
      <Wrapper className={className} id={htmlId} ref={rootRef}>
        <div>
          <H2Large className="title">
            {tRing('ring.contents.titleA')}{' '}
            <span>{tRing('ring.contents.titleB')}</span>
          </H2Large>
          <div className="contents u-hide-scrollbar">
            {data.map((element, index) => {
              return (
                <div key={index} className="box-content-element-wrapper">
                  <div className="box-content-element">
                    <Image
                      src={element.image}
                      alt={element.title as unknown as string}
                      width="200"
                      height="200"
                    />
                  </div>
                  <p className={index == 1 ? 'disclaimer-added' : ''}>
                    {element.title}
                    {index == 1 ? (
                      <span className="disclaimer">
                        *BASED ON REGIONAL-AVAILABILITY
                      </span>
                    ) : null}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </Wrapper>
    );
};
